module.exports = __webpack_public_path__ + "static/media/testimonial-c.8e50e255.png";